<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="ch00_fm02"></a><a id="page_ii"></a><strong>A JOHNS HOPKINS PRESS HEALTH BOOK</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?43d71116